import type { ApiError } from '../api/client';

/**
 * The sign-in screen — rendered INSTEAD of the app shell when there is no session.
 *
 * Without this, a signed-out visitor got the full console chrome with every view failing its own
 * 401 underneath, and no way to sign in. The button appears only when the API told us a sign-in
 * flow exists (the `signIn` hint on its 401): the same bundle is also served by the Access-backed
 * ops host, where `/v1/auth/*` is deliberately dark and reloading is what re-authenticates — so
 * there we say that rather than offer a link that would 404.
 */
export function SignedOut({ error }: { error: ApiError }) {
  // Come back to wherever they were, hash route included (the API re-validates this server-side).
  const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const href = error.signIn
    ? `${error.signIn}?returnTo=${encodeURIComponent(returnTo)}`
    : undefined;

  return (
    <div className="app signed-out">
      <div className="brand">
        🐕 Guard Dog <span className="muted">Console</span>
      </div>
      <h1>Sign in</h1>
      <p className="muted">Your session has expired or you’re not signed in yet.</p>
      {href ? (
        <p>
          <a className="button" href={href}>
            Sign in
          </a>
        </p>
      ) : (
        <p className="muted">Reload this page to sign in again.</p>
      )}
    </div>
  );
}
